import { useTranslation } from 'react-i18next'
import { Info } from 'lucide-react'

export default function ContractNotice() {
  const { t } = useTranslation('contract')

  return (
    <div className="flex items-start gap-3 p-4 bg-blue-50 border border-blue-200 rounded-xl">
      <Info className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" />
      <div>
        <p className="text-sm text-blue-800">
          {t('notice.message')}
        </p>
        <p className="text-sm text-blue-600 mt-1">
          {t('notice.email')} <a href="mailto:aiqedu@quebon.com" className="underline">aiqedu@quebon.com</a>
        </p>
      </div>
    </div>
  )
}
